import api from '../api'

const baseUrl = '/academy/api/Campaign'

const dadbanCampaignProvider = {
  //   getProductsTable(params) {
  //     return api.post(`${baseUrl}/ProductTable`, params)
  //   },
  //   getProductUser(params) {
  //     return api.post(`${baseUrl}/PeopleTable`, params)
  //   },

  getCampaign(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  addCampaign(params) {
    return api.post(`${baseUrl}/Add`, params)
  },
  addProduct(params) {
    return api.post(`${baseUrl}/AddProduct`, params)
  },
  searchProduct(params) {
    return api.post(`${baseUrl}/Search`, params)
  },
  deleteProduct(params) {
    return api.delete(`${baseUrl}/DeleteProduct`, { data: params })
  },

  addDiscount(params = {}) {
    return api.post(`${baseUrl}/AddDiscount`, params)
  },
  runCampaign(params = {}) {
    return api.post(`${baseUrl}/Active`, params)
  },
}

export default dadbanCampaignProvider
